// extracted by mini-css-extract-plugin
export var avatar = "_lp-3";
export var avatarContainer = "_lp-2";
export var avatarSpacer = "_lp-5";
export var avatarSpacerContainer = "_lp-4";
export var avatarStackContainer = "_lp-1";
export var bubble = "_lp-0";
export var remainderBubble = "_lp-6";